import { LinkLabel } from 'mol-ui';
import React from 'react';
import { config } from 'config';
import { images } from 'styled';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    Container,
    Link,
    Logo,
    Text404,
    TextContainer,
    TextError,
    TextSubError,
    Version
} from './styled';
const { logo } = images;
const { version } = config;

const Error404 = () => {
    
    const { t } = useTranslation();
    const { push } = useHistory();

    return (
        <Container>
            <TextContainer>
                <Text404>404</Text404>
                <TextError>{ t('Página no encontrada') }</TextError>
                <TextSubError>{ t('El link al que intentas ingresar no existe o no se encuentra habilitado para su cuenta') }</TextSubError>
                <Logo alt="logo" src={ logo } />
                <Link>
                    <LinkLabel onClick={ () => push('/') }>
                        { t('Volver al inicio') }
                    </LinkLabel>
                </Link>
                <Version>v{ version }</Version>
            </TextContainer>
        </Container>
    );
};

Error404.propTypes = {

};

export default Error404;
